// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Link,
  CardMedia,
  Typography,
  Table,
  Tab,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { CustomPaginationCommon } from "modules/Users/components";
import { useNavigate, useParams } from "react-router-dom";
import "../../../../styles/paymentTable.css"; // Import the CSS file
import { AddPaymentModal } from "./AddPaymentModal";
import { ConfirmModal } from "components";
import Tooltip from "@mui/material/Tooltip";
import { PaymentMethodsTypes } from "types";
import { Content as ContentType } from "types";
import { useAuth } from "context/authContext";
import { PaymentMethodService } from "services/PaymentMethodService";
import { Timestamp } from "firebase/firestore";
import { ContentsService } from "services/ContentsService";
import { PurchasesService } from "services/PurchasesService";

const PaymentTable = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [mode, setMode] = useState<"add" | "edit">("add");
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState<
    Partial<PaymentMethodsTypes>
  >({
    id: "",
    userId: currentUser?.uid ?? "", // Set as string
    cardName: "",
    accountNumber: "",
    cvcNumber: "",
    cardNickName: "",
    dateExpiration: null,
  });

  const [showFullText, setShowFullText] = useState(false);
  const [selectedCardIndex, setSelectedCardIndex] = useState<number | null>(
    null
  );
  const [paymentCards, setPaymentCards] = useState<PaymentMethodsTypes[]>([]);
  const [userPurchaseData, setUserPurchaseData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch all payment methods for the logged-in user
  useEffect(() => {
    const fetchPaymentMethods = async () => {
      if (!currentUser?.uid) return;
      setLoading(true);
      try {
        const methods = await PaymentMethodService.getPaymentMethodsByUser(
          currentUser.uid
        );
        setPaymentCards(methods);

        const puchaseData = await PurchasesService.getPurchasesByUser(
          currentUser.uid
        );

        setUserPurchaseData(puchaseData);
      } catch (error) {
        console.error("Error fetching payment methods:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPaymentMethods();
  }, [currentUser]);

  const handleToggleText = () => {
    setShowFullText((prev) => !prev);
  };

  const handleClose = () => setOpen(false);
  const handleConfirmOpen = (index: number) => {
    setSelectedCardIndex(index ?? null);
    setConfirmOpen(true);
  };

  const handleConfirmClose = () => setConfirmOpen(false);

  const handleOpen = (mode: "add" | "edit", index?: number) => {
    setMode(mode);
    if (mode === "edit" && index !== undefined) {
      setInitialValues(paymentCards[index]);
      setSelectedCardIndex(index);
    } else {
      setInitialValues({
        id: "",
        userId: currentUser?.uid ?? "",
        cardName: "",
        accountNumber: "",
        cvcNumber: "",
        cardNickName: "",
        dateExpiration: null,
      });
    }
    setOpen(true);
  };

  const handleSubmit = async (data: PaymentMethodsTypes) => {
    try {
      // Check if the card already exists
      const isDuplicate = paymentCards.some(
        (card) => card.accountNumber === data.accountNumber
      );

      if (isDuplicate) {
        alert("This payment method is already saved.");
        return;
      }

      // Validate Expiry Date
      if (data.dateExpiration) {
        const [month, year] = data.dateExpiration.split("/");
        const expiryDate = new Date(`20${year}`, month - 1); // Convert to YYYY-MM format
        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth()); // Ensure it checks against the current month

        if (expiryDate < currentDate) {
          alert("Please enter a valid expiry date.");
          return;
        }
      }

      if (mode === "add") {
        const newCard = await PaymentMethodService.createPaymentMethod(data);
        setPaymentCards((prev) => [...prev, { ...data, id: newCard.id }]);
      } else if (mode === "edit" && selectedCardIndex !== null) {
        await PaymentMethodService.updatePaymentMethod(data.id, data);
        setPaymentCards((prev) =>
          prev.map((card, index) =>
            index === selectedCardIndex ? { ...card, ...data } : card
          )
        );
      }
      setOpen(false);
    } catch (error) {
      console.error("Error saving payment method:", error);
    }
  };

  const handleDelete = async () => {
    if (selectedCardIndex !== null) {
      try {
        const cardToDelete = paymentCards[selectedCardIndex];
        await PaymentMethodService.deletePaymentMethod(cardToDelete.id);
        setPaymentCards((prev) =>
          prev.filter((_, index) => index !== selectedCardIndex)
        );
        setConfirmOpen(false);
      } catch (error) {
        console.error("Error deleting payment method:", error);
      }
    }
  };

  const payments = [
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
    {
      transactionID: "#123412451",
      date: "June 1, 2024",
      contentName: "Neuropsychology: Brain and Behavior",
      email: "serraozk@mail.com",
      totalPaid: "$30",
    },
  ];

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayedCards = paymentCards.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // const handleNavigateReceipt = () => {
  //   const serializableData = JSON.parse(JSON.stringify(userPurchaseData));
  //   navigate(`/payments/${userPurchaseData[0].transactionId}`, {
  //     state: serializableData,
  //   });
  // };
  const handleNavigateReceipt = (transactionId: string) => {
    // Filter the specific transaction data
    const selectedTransaction = userPurchaseData.find(
      (transaction) => transaction.transactionId === transactionId
    );

    // Serialize the data for navigation
    const serializableData = JSON.parse(JSON.stringify(selectedTransaction));

    // Navigate to the receipt page with the specific transaction data
    navigate(`/payments/${transactionId}`, {
      state: serializableData,
    });
  };


  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      gap={{ xs: 1, md: 5 }}
      px={{ xs: 2, md: "55px" }}
    >
      <Box
        pt={{ xs: 15, md: 3 }}
        fontWeight={700}
        fontSize="35px"
        color="#233F91"
        display="flex"
        alignItems="center"
      >
        Payments
      </Box>
      {/* <Grid item xs={10}>
        <Box
          display={"flex"}
          pb={4}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap={{ xs: 1, md: 0 }}
          flexWrap={{ xs: "wrap", md: "nowrap" }}
        >
          <Box
            fontWeight={500}
            fontSize="28px"
            color="#233F91"
            display="flex"
            alignItems="center"
          >
            Payment Methods
          </Box>
          <Button onClick={() => handleOpen("add")} sx={styleSheet.addNewBtn}>
            <AddIcon />
            Add New
          </Button>
        </Box>

        <>
          {paymentCards.length > 0 ? (
            paymentCards.map((card, index) => (
              <Box
                display={"flex"}
                bgcolor={"#fff"}
                borderRadius={"15px"}
                border={{ xs: "1px solid #D4D4D4", md: "none" }}
                p={2}
                mb={2}
                justifyContent={{ xs: "center", md: "space-between" }}
                alignItems={"center"}
                // width={{ xs: "209px", lg: "100%", md: "100%", xl: "100%" }}
                width={{ xs: "90%", lg: "100%", md: "100%", xl: "100%" }}
                flexWrap={{ xs: "wrap", md: "nowrap" }}
                overflow={"hidden"}
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  gap={{ xs: 2, md: 8 }}
                  flexWrap={{ xs: "wrap", md: "nowrap" }}
                  flexDirection={{ xs: "column", md: "row" }}
                >
                  <CardMedia
                    sx={{
                      width: { xs: "127.76px", md: "148px" },
                      height: { xs: "85px", md: "98px" },
                      ml: { xs: "0px", md: "20px" },
                      objectFit: "cover",
                      mx: { xs: "auto", md: "0px" },
                    }}
                    image={"/assets/icons/crcard.png"}
                  />
                  <Box
                    display={"flex"}
                    flexDirection={{ xs: "column", md: "row" }}
                    gap={{ xs: 2, md: 8 }}
                  >
                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      gap={{ xs: "0px", md: 1 }}
                    >
                      <Box
                        fontWeight={400}
                        fontSize={"17px"}
                        color={"rgba(0, 0, 0, 0.8)"}
                      >
                        Card Number
                      </Box>
                      <Box fontWeight={700} fontSize={"18px"} color={"#595959"}>
                        {card ? card.accountNumber : "**** **** **** 6783"}
                      </Box>
                    </Box>
                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      gap={{ xs: "0px", md: 1 }}
                    >
                      <Box
                        fontWeight={400}
                        fontSize={"17px"}
                        color={"rgba(0, 0, 0, 0.8)"}
                      >
                        Card Nickname
                      </Box>
                      <Box fontWeight={700} fontSize={"18px"} color={"#595959"}>
                        {card ? card.cardNickName : "Bank of America Visa"}
                      </Box>
                    </Box>
                  </Box>

                </Box>
                <Box
                  display={"flex"}
                  gap={2}
                  alignItems={"center"}
                  justifyContent={"center"}
                  pt={{ xs: 2, md: 0 }}
                  flexWrap={{ xs: "wrap-reverse", md: "nowrap" }}
                >
                  <Link
                    sx={styleSheet.linkRed}
                    onClick={() => handleConfirmOpen(index)}
                  >
                    Delete
                  </Link>
                  <Link
                    className="rowLinkBlue"
                    onClick={() => handleOpen("edit", index)}
                  >
                    Edit Payment Information
                  </Link>
                </Box>
              </Box>
            ))
          ) : (
            <></>
          )}
        </>
        <AddPaymentModal
          open={open}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          initialValues={initialValues as PaymentMethodsTypes}
          setInitialValues={setInitialValues}
          mode={mode}
        />
        {/* // delete modal here */}
      <ConfirmModal
        title="Are you sure you want to remove this payment method?"
        subtitle=""
        // subtitle="Figma ipsum component variant main layer. Asset opacity rotate plugin line. Project pen frame share."
        cancelText="Cancel"
        confirmText="Confirm"
        isLoading={false}
        onCancel={handleConfirmClose}
        onConfirm={handleDelete}
        isConfirmModal={confirmOpen}
        warning="Warning"
      />
      {/* </Grid> */}
      {/* /// full screen table */}
      <>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
          // width="100vw"
          >
            <CircularProgress sx={{ color: "#233F91" }} />
          </Box>

        ) : userPurchaseData.length === 0 ? (
          <Box
            flex={1}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          // width="100vw"
          >
            <Typography
              display="flex"
              alignItems="center"
              fontSize={22}
              color="#797979"
              fontWeight={400}
            >
              Your cart is empty
            </Typography>
          </Box>
        ) : (
          <>
            <Box
              display={{ xs: "none", md: "flex" }}
              flexDirection={"column"}
              gap={"20px"}
            >
              <Box
                fontWeight={500}
                fontSize="28px"
                color="#233F91"
                display="flex"
                alignItems="center"
              >
                Payment History
              </Box>
              <Grid item xs={10}>
                <div
                  className="scrollable-container"
                  style={{ display: "flex", flexDirection: "column", gap: "35px" }}
                >
                  <table className="tableHeader">
                    <Typography className="transitionId">Transaction ID</Typography>
                    <Typography className="date">Date</Typography>
                    <Typography className="conatent">Content Name</Typography>
                    <Typography className="emailTotal">Email</Typography>
                    <Typography className="emailTotal">Total Paid</Typography>
                    <Typography className="btnColumn"></Typography>
                  </table>
                  <div
                    className="scrollable-container"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "15px",
                      padding: "24px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "28px",
                    }}
                  >
                    {userPurchaseData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((payment, index) => (
                        <table key={payment.transactionID} className="rowHeader">
                          <Typography className="rowTrasitionId">
                            {payment.transactionId}
                          </Typography>
                          <Typography className="rowDate">
                            {payment?.createdAt
                              ?.toDate()
                              .toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              })}
                          </Typography>
                          <Typography className="rowContent">
                            {payment?.cartItemData?.map((item: any) => (
                              <Typography>{item?.contentData?.title}</Typography>
                            ))}
                          </Typography>
                          <Typography className="rowEmailTotal">
                            {currentUser?.email}
                          </Typography>
                          <Typography className="rowtotalPaid">
                            {payment.amount}
                          </Typography>
                          <Typography className="rowBtn">
                            {/* {index === 0 && (
                        <Link sx={styleSheet.linkRed}>Request Refund</Link>
                      )} */}
                            <Button
                              sx={{
                                ...styleSheet.rowButton,
                                "&:hover": {
                                  backgroundColor: "#233F91",
                                  color: "#fff",
                                },
                              }}
                              onClick={() =>
                                handleNavigateReceipt(payment.transactionId)
                              }
                            >
                              View Receipt
                            </Button>
                          </Typography>
                        </table>
                      ))}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <CustomPaginationCommon
                        count={userPurchaseData.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Box>
          </>
        )}

      </>

      {/* /// mobile screen /// */}
      <Box
        display={{ xs: "flex", md: "none" }}
        flexDirection={"column"}
        gap={"20px"}
      >
        <Box
          fontWeight={500}
          fontSize="28px"
          color="#233F91"
          display="flex"
          alignItems="center"
        >
          Payment History
        </Box>
        <Box
          bgcolor={"#fff"}
          border={"1px solid #E5E5E5"}
          borderRadius={"15px"}
          padding={"10px"}
          display="flex"
          flexDirection={"column"}
          gap={"12px"}
        >
          {/* {payments */}
          {userPurchaseData
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((payment, index) => (
              <Box
                border={"1px solid #E5E5E5"}
                borderRadius={"15px"}
                padding={"10px"}
                pt={3}
                display={"flex"}
                flexDirection={"column"}
                gap={"18px"}
              >
                <Box display={"flex"} gap={2} alignItems={"center"}>
                  <Typography
                    fontWeight={700}
                    fontSize={"13.29px"}
                    color={"#233F91"}
                  >
                    Transaction ID
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontSize={"17px"}
                    color={"#313131"}
                  >
                    {payment.transactionId}
                  </Typography>
                </Box>
                <Box display={"flex"} gap={0} alignItems={"center"}>
                  <Typography
                    fontWeight={700}
                    fontSize={"13.29px"}
                    color={"#233F91"}
                    width={"150px"}
                  >
                    Content Name
                  </Typography>

                  <Typography
                    fontWeight={400}
                    fontSize={"17px"}
                    color={"#313131"}
                    className="ellipsis"
                    onClick={handleToggleText} // Replace with your custom function to show full text
                  >
                    {payment.contentName}
                  </Typography>

                </Box>
                <Box display={"flex"} gap={4} alignItems={"center"}>
                  <Typography
                    fontWeight={700}
                    fontSize={"13.29px"}
                    color={"#233F91"}
                  >
                    Date
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontSize={"17px"}
                    color={"#313131"}
                  >
                    {payment?.createdAt?.toDate().toDateString()}
                  </Typography>
                </Box>

                <Box display={"flex"} gap={"30px"} alignItems={"center"}>
                  <Typography
                    fontWeight={700}
                    fontSize={"13.29px"}
                    color={"#233F91"}
                  >
                    Email
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontSize={"17px"}
                    color={"#313131"}
                  >
                    {currentUser?.email}
                  </Typography>
                </Box>
                <Box display={"flex"} gap={2} alignItems={"center"}>
                  <Typography
                    fontWeight={700}
                    fontSize={"13.29px"}
                    color={"#233F91"}
                  >
                    Total Paid
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontSize={"17px"}
                    color={"#313131"}
                  >
                    {payment.amount}
                  </Typography>
                </Box>
                <Box
                  pt={3}
                  display={"flex"}
                  gap={2}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                  mr={3}
                >
                  {/* {index === 0 && (
                    <Link sx={styleSheet.linkRed}>Request Refund</Link>
                  )} */}
                  <Box>
                    <Button
                      sx={{
                        ...styleSheet.rowButton,
                        "&:hover": {
                          backgroundColor: "#233F91",
                          color: "#fff",
                        },
                      }}
                      // onClick={() => navigate(`/payments/${userType}`)}
                      onClick={() =>
                        handleNavigateReceipt(payment.transactionId)
                      }
                    >
                      View Receipt
                    </Button>
                  </Box>
                </Box>
              </Box>
            ))}
          <Box>
            <CustomPaginationCommon
              count={userPurchaseData.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default PaymentTable;

const styleSheet = {
  linkRed: {
    cursor: "pointer",
    color: "red",
    fontWeight: 700,
    fontSize: "13.29px",
    textDecoration: "underline",
    textUnderlineOffset: "3px",
  },
  rowButton: {
    borderRadius: "15px",
    width: "154px",

    height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: "16px",
    fontWeight: 700,
  },
  addNewBtn: {
    borderRadius: "15px",
    width: { xs: "131px", md: "186px" },
    height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: "15px",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
};
